import axios from '@/axios/globalaxios'
// /api/kline?symbol=sh000300&period=d&start=20250211
export const findByBlockTrade = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByBlockTrade",
        method: 'post',
        data
    })
}
//交易所
export const findByTradingPost = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByTradingPost",
        method: 'post',
        data
    })
}
//深证
export const findBySzIndustry = data =>{
    return axios({
        url: "/tradelab/cluster_source/findBySzIndustry",
        method: 'post',
        data
    })
}
//中证
export const findByZzIndustry = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByZzIndustry",
        method: 'post',
        data
    })
}
export const findByIndustryClassification = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByIndustryClassification",
        method: 'post',
        data
    })
}

//利润汇总表
export const findByCalculationSummary = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByCalculationSummary",
        method: 'post',
        data
    })
}
export const findByCalculationSummaryYear = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByCalculationSummaryYear",
        method: 'post',
        data
    })
}
//利润分配表

export const findByProfitDistribution = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByProfitDistribution",
        method: 'post',
        data
    })
}

export const findByProfitDistributionYear = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByProfitDistributionYear",
        method: 'post',
        data
    })
}

//现金流量表

export const findByCashFlow = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByCashFlow",
        method: 'post',
        data
    })
}
export const findByCashFlowYear = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByCashFlowYear",
        method: 'post',
        data
    })
}
//findByBeInDebt 负债信息
export const findByBeInDebtYear = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByBeInDebtYear",
        method: 'post',
        data
    })
}

export const findByBeInDebt = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByBeInDebt",
        method: 'post',
        data
    })
}

// 复权因子
export const findByAdjustingFactor = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByAdjustingFactor",
        method: 'post',
        data
    })
}
// findByTradingHaltInfo 停牌复牌表
export const findByTradingHaltInfo = data =>{
    return axios({
        url: "/tradelab/cluster_source/findByTradingHaltInfo",
        method: 'post',
        data
    })
}

export const findStockDetail =data=>{
    return axios({
        url: "/tradelab/cluster_source/findStockDetail",
        method: 'post',
        data
    })
}
export const getkline =data=>{
    return axios(
        {
        responseType: 'blob',
        url: "/tradelab/ai/finance/kline",
        method: 'get',
        params:data
    })
}
export const getfundflow =data=>{
    return axios(
        {
        responseType: 'blob',
        url: "/tradelab/ai/finance/fundflow",
        method: 'get',
        params:data
    })
}
export const outline =data=>{
    return axios(
        {
        url: "/tradelab/ai/finance/outline",
        method: 'post',
        data
    })
}
export const report =data=>{
    return axios(
        {
        url: "/tradelab/ai/finance/report",
        method: 'post',
        data
    })
}
export const generateReport =data=>{
    return axios(
        {
        url: "/tradePy/ai/stream_generate_report",
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}



